/*
 *
 * AssignBlocksReinvestigatedCases constants
 *
 */

export const DEFAULT_ACTION ="app/AssignBlocksReinvestigatedCases/DEFAULT_ACTION";
export const FORMDATA = "app/AssignBlocksReinvestigatedCases/BLOCKDATA";
export const SETFORMDATA = "app/AssignBlocksReinvestigatedCases/BLOCKDATA/SET/VALUE";